export const SITE_CONTACT_LABEL_TEXT = 'Select primary site contact';
